import {createReducer, createActions} from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */
const {Types, Creators} = createActions({
  moreAdsRequest: ['id', 'page', 'page_size'],
  moreAdsSuccess: ['list'],

  followAuthorSuccess: ['authorId', 'followed'],

  savePublicationSuccess: ['publicationId', 'saved'],

  moreAdsReset: null,

  moreAdsFetchingReset: null,
})

export const MoreAdsTypes = Types
export default Creators

/* ------------- Initial State ------------- */
export const INITIAL_STATE = Immutable({
  list: null,
  fetching: false,

  page: 1,
  page_size: 12,
})

/* ------------- Selectors ------------- */
export const MoreAdsSelectors = {
  getState: state => state.moreAds,
}

/* ------------- Reducers ------------- */

export const moreAdsRequest = (state, {id, page, page_size}) => {
  const newState = {
    fetching: true,
  }

  page && (newState.page = page)
  page_size && (newState.page_size = page_size)

  return state.merge(newState)
}

export const moreAdsSuccess = (state, {list}) => {
  return state.merge({fetching: false, list})
}

export const moreAdsReset = state => {
  return INITIAL_STATE
}

export const followAuthorSuccess = (state, {authorId, followed}) => {
  if (state.list?.results) {
    const newResults = state.list?.results?.map(post => {
      if (post.author.id === authorId) {
        return {...post, author: {...post.author, is_following: followed}}
      } else {
        return {...post}
      }
    })
    const newList = {...state.list, results: [...newResults]}

    return state.merge({list: newList})
  } else {
    return state
  }
}

export const savePublicationSuccess = (state, {publicationId, saved}) => {
  if (state.list?.results) {
    const newResults = state.list?.results?.map(post => {
      if (post.id === publicationId) {
        return {...post, is_saved: saved}
      } else {
        return {...post}
      }
    })
    const newList = {...state.list, results: [...newResults]}

    return state.merge({list: newList})
  } else {
    return state
  }
}

export const moreAdsFetchingReset = state => {
  return state.merge({fetching: false})
}

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.MORE_ADS_REQUEST]: moreAdsRequest,
  [Types.MORE_ADS_SUCCESS]: moreAdsSuccess,

  [Types.FOLLOW_AUTHOR_SUCCESS]: followAuthorSuccess,
  [Types.SAVE_PUBLICATION_SUCCESS]: savePublicationSuccess,

  [Types.MORE_ADS_RESET]: moreAdsReset,
  [Types.MORE_ADS_FETCHING_RESET]: moreAdsFetchingReset,
})
